import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Mens from './components/Mens';
import Womens from './components/Womens';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import Home from './components/Home';
import ProductDescription from './components/ProductDescription';
import MyProfile from './components/MyProfile';

const App = () => {
  return (
    <Router>
      <Header /> {/* The Header includes the Login and Register modals */}
      
      <div>
        <Routes>
          <Route
            path="/"
            element={<Home/>}
          />
          <Route
            path={`/categories/:categoryCode/:category`}
            element={<Mens/>}
          />
          <Route
            path="/products/:productId"
            element={<ProductDescription/>}
          />
          <Route path="/cart" element={<Cart />} />
          <Route path="/myprofile" element={<MyProfile />} />
          <Route path="/checkout" element={<Checkout />} />
        </Routes>
      </div>
      
      <Footer /> {/* Footer */}
    </Router>
  );
};

// const mainContentStyle = {
//   minHeight: 'calc(100vh - 140px)', // Adjust for header/footer height
//   padding: '20px',
// };

export default App;
